import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "allow-access-office-list" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "list-loading"
}
const _hoisted_4 = { class: "list list-scrollbar" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "column-space fix-td" }
const _hoisted_12 = { class: "column-space" }
const _hoisted_13 = { class: "column-space" }
const _hoisted_14 = { class: "column-space" }
const _hoisted_15 = { class: "column-space" }
const _hoisted_16 = { class: "column-space" }
const _hoisted_17 = { class: "column-space" }
const _hoisted_18 = { class: "column-space" }
const _hoisted_19 = { class: "column-space" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { colspan: "9" }

import { computed } from 'vue'
import { formatDate } from "@/services/functions"
import ResizableList from '@/components/ResizableList.vue';
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import i18n from '@/lang/i18n';

const ID = 'id'
const ACCOUNT_NAME = 'account_name'
const OFFICEABLE_TYPE = 'officeable_type'
const OFFICEABLE_NAME = 'officeable_name'
const UPDATED_AT = 'updated_at'
const UPDATED_BY = 'updated_by'

const ID_LABEL_KEY = 'pages.allowAccessOffice.list.id'
const ACCOUNT_NAME_LABEL_KEY = 'pages.allowAccessOffice.accountName'
const OFFICEABLE_TYPE_LABEL_KEY = 'pages.allowAccessOffice.list.officeableType'
const OFFICEABLE_NAME_LABEL_KEY = 'pages.allowAccessOffice.list.officeableName'
const ROLE_LABEL_KEY = 'pages.allowAccessOffice.list.role'
const DRIVER_ID_LABEL_KEY = 'pages.allowAccessOffice.list.driverId'
const UPDATED_AT_LABEL_KEY = 'pages.allowAccessOffice.list.updatedAt'
const UPDATED_BY_LABEL_KEY = 'pages.allowAccessOffice.list.updatedBy'
const EDIT_LABEL_KEY = 'pages.allowAccessOffice.list.edit'

const lastElementIndex = 2


export default /*@__PURE__*/_defineComponent({
  __name: 'AllowAccessOfficeAccountList',
  props: {
    selfRoleId: { default: 2 },
    accounts: {},
    isLoading: { type: Boolean, default: true },
    isSearchCompleted: { type: Boolean },
    isManagementOffice: { type: Boolean }
  },
  emits: ['changeSortOrder', 'openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const headerLabelKeys = [
  ID_LABEL_KEY,
  ACCOUNT_NAME_LABEL_KEY,
  OFFICEABLE_TYPE_LABEL_KEY,
  OFFICEABLE_NAME_LABEL_KEY,
  ROLE_LABEL_KEY,
  DRIVER_ID_LABEL_KEY,
  UPDATED_AT_LABEL_KEY,
  UPDATED_BY_LABEL_KEY,
  EDIT_LABEL_KEY
]
const header = computed(() => headerLabelKeys.map((labelKey) => ({
  labelKey,
  label: i18n.global.t(labelKey)
})))
const sortableItems: any = {
  [ID_LABEL_KEY]: ID,
  [ACCOUNT_NAME_LABEL_KEY]: ACCOUNT_NAME,
  [OFFICEABLE_TYPE_LABEL_KEY]: OFFICEABLE_TYPE,
  [OFFICEABLE_NAME_LABEL_KEY]: OFFICEABLE_NAME,
  [UPDATED_AT_LABEL_KEY]: UPDATED_AT,
  [UPDATED_BY_LABEL_KEY]: UPDATED_BY
}
const currentSort: any = { item: 'id', type: 'ASC' }
const sortTypes: any = ['ASC', 'DESC']
const officeableTypeNames: any = {
  ManagementOffice: i18n.global.t('pages.allowAccessOffice.list.managementOffice'),
  SubManagementOffice: i18n.global.t('pages.allowAccessOffice.list.subManagementOffice'),
  OperationOffice: i18n.global.t('pages.allowAccessOffice.operationOffice'),
  InstallationOffice: i18n.global.t('pages.allowAccessOffice.list.installationOffice')
}
const roles: any = {
  1: i18n.global.t('pages.allowAccessOffice.list.administrator'),
  2: i18n.global.t('pages.allowAccessOffice.list.driver')
}
function datetimeFormat(datetime: any) {
  const d = new Date(datetime)
  return formatDate(d)
}

function officeableTypeName(officeableType: any) {
  const type = officeableType.split('\\')[lastElementIndex]
  return officeableTypeNames[type]
}

function officeableName(account: any) {
  const type = account.officeable_type.split('\\')[lastElementIndex]
  if (type == 'OperationOffice') {
    return account.officeable.operation_office_name
  } else {
    return account.officeable.company_name
  }
}

function emitChangeSortOrder(labelKey: string, sortType: any = null) {
  if (!sortableItem(labelKey)) return

  const item: any = sortableItems[labelKey]
  if (sortType) {
    currentSort.type = sortType
  } else {
    if (currentSort.item == item) {
      const type: any = sortTypes.find((type: any) => type != currentSort.type)
      currentSort.type = type
    } else {
      currentSort.type = sortTypes[0]
    }
  }
  currentSort.item = item
  emits('changeSortOrder', currentSort.item, currentSort.type)
}

function sortableItem(labelKey: string) {
  return Object.keys(sortableItems).includes(labelKey)
}

function addClassIfSortable(labelKey: string) {
  if (!sortableItem(labelKey)) return

  return 'sort-icon pl-2 pt-1'
}

function highLightIfCurrentSort(labelKey: string, type: string) {
  if (currentSort.item != sortableItems[labelKey] || currentSort.type != type) return

  return 'fw-bold'
}

function applyLeftClass(index: number) {
  if (index == 0) return 'start-0'
}

function openModal(account: any | null) {
  emits('openModal', account)
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : (!__props.isSearchCompleted && __props.isManagementOffice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".list" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header.value, (item, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("th", {
                      key: item.labelKey,
                      class: _normalizeClass(["table-header column-space", applyLeftClass(index)])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (sortableItem(item.labelKey))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["nc-icon nc-stre-up sort-icon d-block", highLightIfCurrentSort(item.labelKey, sortTypes[0])]),
                                onClick: ($event: any) => (emitChangeSortOrder(item.labelKey, sortTypes[0]))
                              }, null, 10, _hoisted_8),
                              _createElementVNode("div", {
                                class: _normalizeClass(["nc-icon nc-stre-down sort-icon d-block", highLightIfCurrentSort(item.labelKey, sortTypes[1])]),
                                onClick: ($event: any) => (emitChangeSortOrder(item.labelKey, sortTypes[1]))
                              }, null, 10, _hoisted_9)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(addClassIfSortable(item.labelKey)),
                          onClick: ($event: any) => (emitChangeSortOrder(item.labelKey))
                        }, _toDisplayString(item.label), 11, _hoisted_10)
                      ])
                    ], 2)), [
                      [_vShow, item.labelKey != EDIT_LABEL_KEY || __props.selfRoleId == 1]
                    ])
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (__props.accounts?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.accounts, (account) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: account.id
                      }, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(account.id), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(account.last_name + ' ' + account.first_name), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(officeableTypeName(account.officeable_type)), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(officeableName(account)), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(roles[account.role_id]), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(account.driver_id), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(datetimeFormat(account.updated_at)), 1),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(DisplayFullnameFromUpdatedBy, {
                            updatedBy: account.updated_by
                          }, null, 8, ["updatedBy"])
                        ]),
                        _withDirectives(_createElementVNode("td", _hoisted_19, [
                          _createElementVNode("div", {
                            class: "material-symbols-outlined edit-icon",
                            onClick: ($event: any) => (openModal(account))
                          }, "edit_note", 8, _hoisted_20)
                        ], 512), [
                          [_vShow, __props.selfRoleId == 1]
                        ])
                      ]))
                    }), 128))
                  : (!__props.accounts?.length && !__props.isLoading && __props.isSearchCompleted)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})